import { Float, ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { authenticatedMiddleware } from '../../permissions/middlewares/authenticatedMiddleware.js';
import { checkAbacOnViewedUserMiddleware } from '../../permissions/middlewares/checkAbacOnViewedUserMiddleware.js';
import { UserEmployeeDetailsActions } from '../../users/employees/UserEmployeeDetailsPolicy.js';
import { LAKAdjustment } from '../entities/LAKAdjustment.js';
import { LAKIntervall, LAKIntervallResult } from '../entities/LAKIntervallResult.js';
import { resolveCalculateLAKIntervallsForPerson } from '../server/resolvers/resolveCalculateLAKIntervallsForPerson.js';
import {
  resolveDeleteLAKAdjustmentForPerson,
  resolvePreviewLAKAdjustmentWeeks,
  resolveSaveLAKAdjustmentForPerson,
} from '../server/resolvers/resolveLAKAdjustments.js';
import { resolveSetPreviousLAKHoursForPerson } from '../server/resolvers/resolveSetPreviousLAKHoursForPerson.js';

const calculateLAKIntervallsForPerson = registerQuery({
  operationName: 'calculateLAKIntervallsForPerson',
  type: () => LAKIntervallResult,
  params: [
    { type: () => ID, name: 'userID' },
    { type: () => Int, name: 'forceRecalculate' },
  ],
  middlewares: [authenticatedMiddleware],
  resolve: resolveCalculateLAKIntervallsForPerson,
});

const setPreviousLAKHoursForPerson = registerMutation({
  operationName: 'setPreviousLAKHoursForPerson',
  type: () => Boolean,
  params: [
    { type: () => ID, name: 'userID' },
    { type: () => Float, name: 'previousLAKHours' },
    { type: () => Int, name: 'previousLAKHoursYear' },
  ],
  middlewares: [checkAbacOnViewedUserMiddleware(UserEmployeeDetailsActions.EDIT_LAK, 'userID')],
  resolve: resolveSetPreviousLAKHoursForPerson,
});

const saveLAKAdjustmentForPerson = registerMutation({
  operationName: 'saveLAKAdjustmentForPerson',
  type: () => Boolean,
  params: [
    { type: () => ID, name: 'userID' },
    { type: () => LAKAdjustment, name: 'adjustment' },
  ],
  middlewares: [checkAbacOnViewedUserMiddleware(UserEmployeeDetailsActions.EDIT_LAK, 'userID')],
  resolve: resolveSaveLAKAdjustmentForPerson,
});

const deleteLAKAdjustmentForPerson = registerMutation({
  operationName: 'deleteLAKAdjustmentForPerson',
  type: () => Boolean,
  params: [
    { type: () => ID, name: 'userID' },
    { type: () => ID, name: 'adjustmentID' },
  ],
  middlewares: [checkAbacOnViewedUserMiddleware(UserEmployeeDetailsActions.EDIT_LAK, 'userID')],
  resolve: resolveDeleteLAKAdjustmentForPerson,
});

const previewLAKAdjustmentWeeks = registerQuery({
  operationName: 'previewLAKAdjustmentWeeks',
  type: () => LAKIntervall,
  params: [
    { type: () => ID, name: 'userID' },
    { type: () => Date, name: 'start' },
    { type: () => Date, name: 'end' },
  ],
  middlewares: [checkAbacOnViewedUserMiddleware(UserEmployeeDetailsActions.EDIT_LAK, 'userID')],
  resolve: resolvePreviewLAKAdjustmentWeeks,
});

export const LakAPI = {
  calculate: calculateLAKIntervallsForPerson,
  setPreviousHours: setPreviousLAKHoursForPerson,
  saveAdjustment: saveLAKAdjustmentForPerson,
  deleteAdjustment: deleteLAKAdjustmentForPerson,
  previewAdjustmentWeeks: previewLAKAdjustmentWeeks,
};
